import http from './';
import AsyncStorage from "@react-native-async-storage/async-storage";

export const fetchHistories = async () => {
  const token = await AsyncStorage.getItem("token");
    try {
        const headers = {
          'x-auth':JSON.parse(token),
          "Content-Type": "application/json",
          }        
        const { data } = await http.get(`${http.url2}/lastUpdate`,{
            headers: headers
          });
        return data.Data;
    } catch (err) {
        console.log(err);
    }
};
